define('presentation/settings/liveReceptionistScripts/validators/addLiveReceptionistScriptViewModelValidator',['presentation/common/validation/commonValidator',
    'presentation/common/validation/validationRule'
], function () {
    return function () {
        const self = this;

        let _addLiveReceptionistScriptViewModel;
        let _addLiveReceptionistScriptFacade;

        const CommonValidatorConstructor = require('presentation/common/validation/commonValidator');
        const ValidationRulesConstructor = require('presentation/common/validation/validationRule');

        let _commonValidator = null;

        self.registerViewModel = (addLiveReceptionistScriptViewModel, addLiveReceptionistScriptFacade) => {
            _commonValidator = new CommonValidatorConstructor(addLiveReceptionistScriptViewModel);

            const validationRules = new ValidationRulesConstructor();

            validationRules.field("displayName")
                .addValidationI18n(_commonValidator.isStringWithValue, 'addLiveReceptionistScript:nameRequired');

            _addLiveReceptionistScriptViewModel = addLiveReceptionistScriptViewModel;
            _addLiveReceptionistScriptFacade = addLiveReceptionistScriptFacade;

            _commonValidator.useManualValidation();
            _commonValidator.setValidationRules(validationRules);
        };

        self.validate = () => {
            return _commonValidator.validate();
        };
    };
});

